import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewPayrunPage () {
  const location = useLocation()
  const { t } = useTranslation()
  const payrun = location?.state?.payrun || null

  const columns = [
    { field: 'payment_date', header: t('payment_date') },
    { field: 'pay_period', header: t('pay_period') },
    {
      header: t('name'),
      body: row => `${row.employee?.first_name || ''} ${row.employee?.last_name || ''}`
    },
    { field: 'basic_salary', header: t('basic_salary'), body: row => `${row?.basic_salary ?? 0} ${t('SAR')}` },
    { field: 'allowances', header: t('allowances'), body: row => `${row?.allowances ?? 0} ${t('SAR')}` },
    { field: 'deductions', header: t('deductions'), body: row => `${row?.deductions ?? 0} ${t('SAR')}` },
    { field: 'net_salary', header: t('net_salary'), body: row => `${row?.net_salary ?? 0} ${t('SAR')}` },
    { field: 'gosi_contribution', header: t('gosi_contribution'), body: row => `${row?.gosi_contribution ?? 0} ${t('SAR')}` }
  ]

  if (!payrun) {
    return (
      <div>
        <PageHeader title={t('Payrun Details')} />
        <p className='mt-4'>{t('No_payrun_selected')}</p>
        <div className='mt-4'>
          
        </div>
      </div>
    )
  }

  const data = [payrun]

  return (
    <div>
      <PageHeader title={t('Payrun Details')} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
